/*
 * @Author: Kuiper
 * @Date: 2021-06-12 10:03:34
 * @LastEditTime: 2021-06-25 15:48:39
 */
// https://vuex.vuejs.org/en/modules.html

const allModules = import.meta.globEager('./*/*.ts')
// console.log('allModules:', allModules)

const modules: any = {}

Object.keys(allModules).forEach((key) => {
  const path = key.replace(/(\.\/|\.ts)/g, '')
  // console.log('path:', path)
  const [namespace, imported] = path.split('/')
  if (!modules[namespace]) {
    modules[namespace] = {
      namespaced: true,
    }
  }
  modules[namespace][imported] = allModules[key].default || {}
  // console.log('modules:', modules)
})

export default modules
